import React from 'react';

import { BuildBadge } from '@ledium/ui-build-badge';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import { ColorModeProvider, useColorMode } from './colorMode';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import { createLediumTheme } from './ledium-theme';
import LediumRouter from './LediumRouter';
import { GlobalStoreProvider } from './store/globalStore/context/globalContext';

function AppShell() {
    const { colorMode } = useColorMode();
    const theme = React.useMemo(() => createLediumTheme(colorMode), [colorMode]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <GlobalStoreProvider>
                    <LediumRouter />
                </GlobalStoreProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

function App() {
    return (
        <>
            <GlobalErrorBoundary>
                <ColorModeProvider>
                    <AppShell />
                </ColorModeProvider>
            </GlobalErrorBoundary>
            <BuildBadge />
        </>
    );
}

export default App;
